import React, { useState, useEffect } from "react";
import Styles from "./Ongoing_Connections_Table.module.css";
import { Skeleton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../../commons/Accordion";
import {
  getequisitionsBidders,
  getequisitionsList,
  getDocument,
} from "../../../../../Services/ReverseAuction/GetApi";
import { LeftButton, RightButton } from "./ViewButtons";
import DownloadIcon from "@mui/icons-material/Download";
import { usePdfPreview } from "../../../../../hooks/usePdfPreview";
import { SuccessMessage } from "../../../../../commons/Toast/ErrorMessage";
import { formatSlotTime } from "../../../../../helpers/dateFormat";

const OngoingRATable = ({
  data,
  isLoading,
  currentPage,
  itemsPerPage,
  totalCount,
  onPageChange,
  tenderData,
  isCB,
}) => {
  data?.forEach((item, idx) => {
  });

  const [expanded, setExpanded] = useState(null);

  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day} ${month} ${year} ${hours}:${minutes}`;
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const handleDownload = async (id) => {
    const response = await getDocument(id);
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], {
        type: "application/pdf",
      })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `tender_${tenderData?.id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Listing downloaded successfully!");
  };

  const toggleAccordion = (index) =>
    setExpanded((prev) => (prev === index ? null : index));

  const skeletonRowCount = data?.length > 0 ? data.length : 8;

  if (!isLoading && (!data || data.length === 0)) {
    return <div></div>;
  }

  return (
    <div className={Styles.ongoingBankingMainContainer}>
      <div className={`display_flex_row_center ${Styles.tableActiveCont}`}>
        <div className={`${Styles.tableHeaderActive} display_flex_row`}>
          <div style={{ width: "1%" }}></div>
          <div style={{ width: "25%" }}>E:Tender No.</div>
          {!isCB && (
            <div
              style={{
                width: "25%",
                paddingLeft: "55px",
                paddingRight: "75px",
              }}
            >
              E:RA No.
            </div>
          )}
          <div style={{ width: "20%", paddingRight: "35px" }}>Tender Start</div>
          <div style={{ width: "20%", paddingRight: "35px" }}>Tender End</div>
          <div style={{ width: "15%" }}>EMD</div>
          <div style={{ width: "15%" }}>Actions</div>
        </div>
      </div>
      <div className={`${Styles.tableContentOngoing}`}>
        {isLoading ? (
          <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
            {Array.from({ length: skeletonRowCount }).map((_, i) => (
              <div
                key={i}
                className={`${Styles.activeAccordion} ${
                  i % 2 === 0 ? Styles.accordionEven : Styles.accordionOdd
                }`}
                style={{
                  minHeight: 45,
                  marginBottom: "2px",
                }}
              >
                <div
                  className={`display_flex_row ${Styles.tableActiveCont}`}
                  style={{
                    minHeight: 45,
                    alignItems: "center",
                  }}
                >
                  <div className={Styles.tableAccordionData}>
                    <div style={{ width: "2%" }}>
                      <Skeleton variant="circular" width={24} height={24} />
                    </div>
                    <div style={{ width: "12%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "10%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "8%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                    <div style={{ width: "15%" }}>
                      <Skeleton variant="text" width="90%" height={20} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
            {data.map((item, i) => {
              const row = item.item;


              if (!row) return null;
              return (
                <Accordion
                  key={row.id}
                  expanded={expanded === i}
                  onChange={() => toggleAccordion(i)}
                  className={`${Styles.activeAccordion} ${
                    expanded === i ? Styles.expandedAccordion : ""
                  }`}
                >
                  <AccordionSummary sx={{ minHeight: 45 }}>
                    <div
                      className={`display_flex_row ${Styles.tableActiveCont} ${
                        expanded === row.id
                          ? Styles.expandedRow
                          : row.id % 2 === 0
                          ? Styles.accordionEven
                          : Styles.accordionOdd
                      }`}
                    >
                      <div className={Styles.tableAccordionData}>
                        <div style={{ width: "5%" }}>
                          <div
                            style={{
                              width: 24,
                              height: 24,
                              position: "absolute",
                              top: "50%",
                              transform: "translate(-50%, -50%)",
                              color: "#C5C5CBD9",
                            }}
                          >
                            <ExpandMoreIcon
                              className={`${Styles.expandIconLeft} ${
                                expanded === i ? Styles.rotateIcon : ""
                              }`}
                              style={{
                                width: 24,
                                height: 24,
                              }}
                            />
                          </div>
                        </div>
                        <div
                          style={{ width: isCB ? "50%" : "35%" }}
                          className={Styles.companyLeft}
                        >
                          {item.tenderNumber}
                        </div>
                        {!isCB && (
                          <div style={{ width: "35%", paddingRight: "70px" }}>
                            {item.auctionNumber}
                          </div>
                        )}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: isCB
                              ? "230px 220px 140px"
                              : "160px 160px 80px",
                            columnGap: "32px",
                            alignItems: "start",
                          }}
                        >
                          <div style={{ textAlign: "left" }}>
                            {formatDateTime(item.tenderStartDateTime)}
                          </div>

                          <div style={{ textAlign: "left" }}>
                            {formatDateTime(item.tenderCloseDateTime)}
                          </div>

                          <div style={{ paddingRight: isCB ? "60px" : "0px" }}>
                            {item.emdPerMw}
                          </div>
                        </div>

                        <div
                          style={{
                            width: "20%",
                            paddingRight: isCB ? "40px" : "20px",
                          }}
                        >
                          {/* <DownloadIcon
                            fontSize="small"
                            onClick={() => handleDownload(item?.listingId)}
                            style={{ cursor: "pointer" }}
                          /> */}
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className={Styles.accordianContainer}>
                      <div className={Styles.counterpartyCOntainer}>
                        <div className={Styles.headerBox}>
                          <span style={{ paddingLeft: "12px" }}>
                            Contacts Formed
                          </span>
                          <span style={{ paddingRight: "22px" }}>Quantity</span>
                          <span style={{ paddingRight: "28px" }}>
                            Energy Rate
                          </span>
                          <span style={{ paddingRight: "2px" }}>
                            Date Range
                          </span>
                          <span style={{ paddingRight: "45px" }}>
                            Time Range
                          </span>
                        </div>
                        <div className={Styles.slotContainer}>
                          {/* Loop 1: Loop through each Generator Group (e.g., "Test Gen 2_1", "Solar Energy") */}
                          {item.bilateralConnection.map(
                            (generatorGroup, outerIdx) => (
                              <div
                                key={outerIdx}
                                className={Styles.generatorSection}
                              >
                                {/* Display the Company/Generator Name */}
                                <div className={Styles.companyName}>
                                  <span className={Styles.company_title}>
                                    {generatorGroup.generatorName}
                                  </span>
                                </div>

                                {/* Loop 2: Loop through the actual contract details (slots) within that generator group */}
                                {generatorGroup.bilateralConnection.map(
                                  (slot, innerIdx) => {
                                    if (!slot) {
                                      return null;
                                    }
                                    return (
                                      <div
                                        key={slot.id || innerIdx}
                                        className={Styles.slotbox}
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns:
                                            "150px 160px 220px 240px 200px",
                                          alignItems: "center",
                                          columnGap: "0px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            paddingRight: "75px",
                                            paddingLeft: "0px",
                                          }}
                                        >
                                          Contract {innerIdx + 1}
                                        </span>
                                        <span
                                          style={{
                                            paddingRight: "0px",
                                            paddingLeft: "85px",
                                          }}
                                        >
                                          {slot.quantity} (MW)
                                        </span>
                                        <span
                                          style={{
                                            paddingRight: "0px",
                                            paddingLeft: "130px",
                                          }}
                                        >
                                          {slot.amount} (₹/kWh)
                                        </span>
                                        <span
                                          style={{
                                            paddingRight: "0px",
                                            paddingLeft: "75px",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {formatDate(slot.dateStartAt)} -{" "}
                                          {formatDate(slot.dateEndAt)}
                                        </span>
                                        <span
                                          style={{
                                            paddingRight: "0px",
                                            paddingLeft: "55px",
                                          }}
                                        >
                                          {formatSlotTime(slot.slotStartAt)} -{" "}
                                          {formatSlotTime(slot.slotEndAt)}
                                        </span>
                                      </div>
                                    );
                                  }
                                )}
                                <div className={Styles.buttonbox}>
                                  <LeftButton
                                    clickedIndex={`${i}-${outerIdx}`}
                                    status={item.tenderStatus}
                                    item={item}
                                    source={generatorGroup}
                                  />
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </div>
        )}
        <div className={Styles.paginationWrapper}>
          <button
            disabled={currentPage <= 0}
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            disabled={currentPage + 1 >= totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default OngoingRATable;
